// src/components/auth/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem("authToken");

    if (!token) {
        toast.error("Veuillez vous connecter d'abord!",
            { position: "top-center" }
        )
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;